// extracted by mini-css-extract-plugin
export var blue = "_2p-f";
export var brand = "_2p-b";
export var darkGrey = "_2p-e";
export var disabled = "_2p-4";
export var disabledSubtle = "_2p-5";
export var error = "_2p-6";
export var green = "_2p-g";
export var grey = "_2p-d";
export var icon = "_2p-0";
export var inherit = "_2p-a";
export var lightGrey = "_2p-c";
export var orange = "_2p-i";
export var pink = "_2p-k";
export var primary = "_2p-1";
export var purple = "_2p-l";
export var red = "_2p-j";
export var secondary = "_2p-2";
export var success = "_2p-9";
export var tertiary = "_2p-3";
export var warning = "_2p-7";
export var warningSecondary = "_2p-8";
export var white = "_2p-m";
export var yellow = "_2p-h";